<template>
    <customModal :containermd="true" :bodysm="true" @closeModal="closeActivityModal()">
        <template #title>
            {{ $t("navigations.visit activity") }}
        </template>
        <template #body>
            <div class="row" v-if="fromPage == 'studyProfile'">
                    <div class="col-lg-5">
                        <label class="col-form-label">{{ $t("navigations.activity name") }}<sup><i class="fa fa-asterisk required"></i></sup></label>
                        <select v-model="activityForm.selectedActivityId" @change="validations[0] = false" class="form-select">
                            <option disabled value="">{{ $t("navigations.select") }}</option>
                            <option v-for="activity in activityOptions" :key="activity.id" :value="activity.id">
                                {{ activity.activityName }}
                            </option>
                        </select>
                        <span class="errormsg ml-0" v-if="validations[0] == true">
                                {{ $t("navigations.please select an activity name") }}
                        </span>
                    </div>
                    <div class="col-lg-5">
                        <label class="col-form-label">{{ $t("navigations.activity order") }}<sup><i class="fa fa-asterisk required"></i></sup></label>
                        <select v-model="activityForm.order" class="form-select" @change="validations[1] = false">
                            <option value="" disabled> {{ $t("navigations.select") }} </option>
                            <option
                                v-for="i in Array.from({ length: activityCount + 1 }, (_, index) => activityCount + 1 - index)"
                                :key="i"
                                :value="i"
                            >
                                {{ i }}
                            </option>
                        </select>
                        <span class="errormsg ml-0" v-if="validations[1] == true">
                                {{ $t("navigations.please select an activity order") }}
                        </span>
                    </div>
                    <div class="col-lg-2 align-self-center py-4" style="margin-top:2px">
                        <button class="save_btn py-1 px-4 w-100" @click="addActivity()">
                            {{ $t("navigations.add") }}
                        </button>
                    </div>
            </div>
            <div class="row align-items-end">
                    <div v-if="activityCount == 0" class="text-center py-3">
                    {{ $t("navigations.no activities found") }}
                    </div>
                    <div v-else class="col-lg-12 mt-3">
                    <table class="table table-bordered table-striped">
                        <thead>
                            <tr>
                                
                                <th>{{ $t("navigations.activity order") }}</th>
                                <th>{{ $t("navigations.activity name") }}</th>
                                <th
                                 v-if="fromPage !== 'studyProfile'"
                                >{{ $t("navigations.status") }}</th>
                                <th
                                    class="text-center" 
                                >{{ $t("navigations.forms") }}</th>
                                <th 
                                    class="text-center" 
                                    v-if="fromPage == 'studyProfile'"
                                >{{ $t("navigations.edit") }}</th>
                                <th 
                                    class="text-center" 
                                    v-if="fromPage == 'studyProfile'"
                                >{{ $t("navigations.delete") }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in activityList" :key="index">
                                <td>
                                    <div v-if="editingIndex === index">
                                        <select v-model="editedActivity.activityOrder" class="form-select">
                                            <option disabled value="">{{ $t("navigations.select") }}</option>
                                            <option v-for="order in activityOrderOptions(true)" :key="order" :value="order">
                                                {{ order }}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-else>
                                        {{ item.activityOrder }}
                                    </div>
                                </td>
                                <td>
                                    <div v-if="editingIndex === index">
                                        <select v-model="editedActivity.activityId" class="form-select">
                                            <option disabled value="">{{ $t("navigations.select") }}</option>
                                            <option v-for="activity in activityOptions" :key="activity.id"
                                                :value="activity.id">
                                                {{ activity.activityName }}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-else>
                                        {{ item.activityName }}
                                    </div>
                                </td>
                                <td v-if="fromPage !== 'studyProfile'"> {{ item.status }}</td>
                                <td  class="text-center">
                                    <i class="fa fa-file-text edit-delete" @click="openFormsModal(item.visitNo, item.subjectId, item.activityId, item.activityOrder)"></i>
                                </td>
                                <td 
                                    class="text-center"
                                    v-if="fromPage == 'studyProfile'">
                                    <div v-if="editingIndex === index ">
                                        <i class="fa fa-save text-success cursor-pointer me-2"
                                            @click="saveEditedActivity(index)"></i>
                                        <i class="fa fa-times text-danger cursor-pointer" @click="cancelEdit"></i>
                                    </div>
                                    <div v-else>
                                        <i class="fa fa-edit text-primary cursor-pointer"
                                            @click="editActivity(index)"></i>
                                    </div>
                                </td>
                                <td 
                                    class="text-center"
                                    v-if="fromPage == 'studyProfile'">
                                    <i class="fa fa-trash text-danger cursor-pointer" @click="removeActivity(index)"></i>
                                </td>
                            </tr>

                        </tbody>
                    </table>
                    <div class="col-md-12 d-flex justify-content-md-end px-0">
                        <VPagination
                            v-model="currentPage" 
                            :pages="totalPage" 
                            :range-size="1" 
                            active-color="#ededed"
                            @update:modelValue="loadPage" />
                    </div>
                </div>
            </div>
        </template>
        
    </customModal>
    <StudyActivityForms
        v-if="showStudyFormModal"
        :soaId ="formActivityId"
        @closeModal = "closeFormModal()"
    />
    <SubActivityForm
        v-if="showSubFormModal"
        :visitNo = "formVisitNo"
        :subjectId = "formPatientId"
        :activityId = "formActivityId"
        :activityOrder = "formActivityOrder"
        @closeModal = "closeFormModal()"
    />     
</template>
<script src="./VisitActivityOrder.js"></script>
<style scoped>
.errormsg {
  min-height: 20px;
  display: block;
}
.modal__schedule__wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 100001 !important;
}

.modal__schedule__container {
  background: #fff;
  width: min(60%, 90%);
  border-radius: 4px;
  position: fixed;
  overflow-x: hidden;
  pointer-events: auto;
}

.modal__schedule__container-forms {
  background: #fff;
  width: min(40%, 90%);
  border-radius: 4px;
  position: fixed;
  overflow-x: hidden;
  pointer-events: auto;
}

.modal__schedule__title {
  background-color: var(--pop-up-background);
  color: #ffffff;
}
</style>
